import { Typography,Grid} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";

const GeneralForm = ({ config, setConfig, setErrorGeneral, errorGeneral, version }) => {
    const { t } = useTranslation();
    const handlePatient = (e) => {
        setConfig({
            ...config, 
            device_setting: { 
                ...config.device_setting, 
                patient: { 
                    ...config.device_setting.patient, 
                    patient_type: e.target.value 
                } 
        }});
    }

    const handleMisc = (e, key) => {
        const newValue = e.target.value
        setConfig((prevConfig) => ({
            ...prevConfig,
            device_setting: {
            ...prevConfig?.device_setting,
            misc: {
                ...prevConfig?.device_setting?.misc,
                [key]: newValue,
            },
            },
        }));
    }

    return (<>
        <Grid item xs={12}>
              <Typography
                color="secondary"
                style={{
                  fontWeight: 500,
                  fontSize: 22,
                  lineHeight: "30px",
                  marginTop: 18,
                }}
              >
                {t("devices.setUp.misc.title")}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.patientLabel")}
                value={config?.device_setting?.patient?.patient_type}
                onChange={(e) => handlePatient(e)}
                auto
                values={[t("common.pediatric"), t("common.adult")]}
              />
            </Grid>
            {version <= 201 ? (
              
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <SelectConfig
                  label={t("devices.setUp.mains_filterLabel")}
                  value={config?.device_setting?.misc?.mains_filter}
                  onChange={(e) => handleMisc(e, 'mains_filter') }
                  kv
                  values={[{ key: 0, value: t("devices.setUp.mains_filter0") }]}
                />
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <SelectConfig
                  label={t("devices.setUp.mains_filterLabel")}
                  value={config?.device_setting?.misc?.mains_filter}
                  onChange={(e) => handleMisc(e, 'mains_filter') }
                  kv
                  values={[
                    { key: 0, value: t("devices.setUp.mains_filter0") },
                    { key: 1, value: "50 Hz" },
                    { key: 2, value: "60 Hz" },
                  ]}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.utc_timeLabel")}
                value={config?.device_setting?.misc?.utc_time}
                onChange={(e) => handleMisc(e, 'utc_time') }
                kv
                values={UTC_TIMELIST}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.volumenLabel")}
                value={config?.device_setting?.misc?.volume}
                onChange={(e) => handleMisc(e, 'volume') }
                values={[1, 2, 3, 4, 5, 6, 7, 8]}
              />
            </Grid>
    </>);
};

const UTC_TIMELIST = [
  { key: -12, value: "UTC-12" },
  { key: -11, value: "UTC-11" },
  { key: -10, value: "UTC-10" },
  { key: -9, value: "UTC-9" },
  { key: -8, value: "UTC-8" },
  { key: -7, value: "UTC-7" },
  { key: -6, value: "UTC-6" },
  { key: -5, value: "UTC-5" },
  { key: -4, value: "UTC-4" },
  { key: -3, value: "UTC-3" },
  { key: -2, value: "UTC-2" },
  { key: -1, value: "UTC-1" },
  { key: 0, value: "UTC 0" },
  { key: 1, value: "UTC+1" },
  { key: 2, value: "UTC+2" },
  { key: 3, value: "UTC+3" },
  { key: 4, value: "UTC+4" },
  { key: 5, value: "UTC+5" },
  { key: 6, value: "UTC+6" },
  { key: 7, value: "UTC+7" },
  { key: 8, value: "UTC+8" },
  { key: 9, value: "UTC+9" },
  { key: 10, value: "UTC+10" },
  { key: 11, value: "UTC+11" },
  { key: 12, value: "UTC+12" },
  { key: 13, value: "UTC+13" },
  { key: 14, value: "UTC+14" },
];

export default GeneralForm;